module.exports = __webpack_public_path__ + "static/media/26UNRWA8.71c937ce.jpg";